/**
 * Wrapper around `console.info` that can be turned on globally via:
 *
 *     logger.setDebugMode(true);
 */
export class Logger {
  private debugMode = false;

  setDebugMode(debugMode: boolean): void {
    this.debugMode = debugMode;
  }

  /** Internal console log function */
  log = (...message: unknown[]): void => {
    if (this.debugMode) {
      console.info('[Metrics SDK]', ...message);
    }
  };
}

export const logger = new Logger();
